module.exports = __webpack_public_path__ + "static/media/bathtub1.1bdb9e42.svg";